module.exports = __webpack_public_path__ + "static/media/3@1280w.69ac35a3.jpg";